
import { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import {useUserInfo} from '../../providers/userProvider'
import { ERR_DESC_ROLEACCESS,ERR_TITLE_ACCESS } from '../../utils/errorLiterals';

export default function Has({children, roles, all, redirectErrorPage, admin}) {
    const userInfo = useUserInfo();
    const errorUrl =  window.location.href;
    let match = false;
    const [userRoles,setUserRoles] = useState([]);
    useEffect(() => {
        if(userInfo){
            setUserRoles(userInfo.roles);
        }
    },[userInfo])
    if(!roles && !admin){
        match = true;
    }else{
        if(!all && admin){
            const adminRoles = userRoles.filter((role) =>role.toUpperCase().includes('ADMIN'));
            match = adminRoles.length>0? true : false;
        }else if(!all){
            roles.forEach((role) =>{
                if(!match){
                    match = userRoles.find((uRole) => uRole === role)? true: false;
                }                
            });
        }else{
            let countRoles =0;
            roles.forEach((role)=>{
                countRoles += userRoles.find((uRole) => uRole === role)? 1: 0;
            })
            match = countRoles === roles.length()? true : false;
        }
    }
    if(match){
        return <>{children}</>
    }else{
        if(redirectErrorPage){
            const userId = userInfo? userInfo.userId : '';
            return <Redirect
                        to={{
                        pathname: '/error',
                        state: {errorTitle: ERR_TITLE_ACCESS,
                                errorDescription: ERR_DESC_ROLEACCESS, 
                                errorUrl: errorUrl, 
                                errorUser: userId}
                        }}
                    />;
        }else{
            return null;
        }
    }
}